var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#0F8482"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.10795C19 8.41858 18.8722 8.69976 18.6671 8.88304L9.73838 17.8118C9.64223 17.9217 9.52539 18.0096 9.39178 18.0704C9.25074 18.1345 9.09925 18.1648 8.94318 18.1648C8.78711 18.1648 8.63562 18.1345 8.49458 18.0704C8.36095 18.0096 8.24409 17.9217 8.14794 17.8117L4.35887 14.0214C4.12781 13.8134 4 13.5322 4 13.2216C4 12.923 4.11814 12.6515 4.33259 12.4462C4.53789 12.2318 4.80932 12.1136 5.10795 12.1136C5.41858 12.1136 5.69976 12.2414 5.88213 12.4456L8.94268 15.4946L17.0923 7.35887C17.3002 7.12781 17.5814 7 17.892 7C18.1907 7 18.4621 7.11814 18.6674 7.33259C18.8819 7.53789 19 7.80932 19 8.10795Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.d70bd6a10e2a48a584f58b629d1ea933.svg";
export { ForwardRef as ReactComponent };